import { Extension } from '@tiptap/core';
import { ZyYoutubeVideoNode, ZyYoutubeVideoNodeHeadless } from './zyyoutubevideo-extension';

export const ZyYoutubeVideoHeadless = Extension.create({
    name: 'zyYoutubeVideoWrapper',

    addOptions() {
        return {};
    },

    addExtensions() {
        return [ZyYoutubeVideoNodeHeadless];
    },
});

export const ZyYoutubeVideo = ZyYoutubeVideoHeadless.extend({
    addExtensions() {
        return [ZyYoutubeVideoNode];
    },
});

export default ZyYoutubeVideo;
